// ==== htmlupdater


function updatePriceAndColor(oldPrice, newPrice, color) {
    try {
        const priceElement = document.querySelector('.price');

        let parsedNewPrice = parseFloat(newPrice);
        if (parsedNewPrice == oldPrice) { resetPrice(); return; }
        priceElement.innerHTML = `
    <span class="price-wrapper" style="display: flex; align-items: center;">
        <span class="new-price" style="color: ${color}; margin-left: 5px; margin-right: 10px;">$${parsedNewPrice + AVPprice}</span>
        <span class="old-price" style="text-decoration: line-through; color: #888; font-size: 0.7em;">$${parseFloat(oldPrice + AVPprice)}</span>
    </span>
    `;
    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}


function resetPrice() {
    try {
        const priceElement = document.querySelector('.price');
        //console.log(initPrice + AVPprice);
        priceElement.innerHTML = `
    <span class="price-wrapper" style="display: flex; align-items: center;">
        <span class="new-price" style="color: #4ba54b; margin-left: 5px;">$${initPrice + AVPprice}</span>
    </span>
    `;
    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}
